import {
  createArticleCategory,
  editArticleCategory,
  getArticleCategoryById,
} from 'http/articleCategoryApi';

import { defaultArticleCategoryEntity } from 'common/constants';
import { IArticleCategory, ICreateArticleCategory } from 'common/types';
import { notify } from 'common/utils';
import { makeAutoObservable } from 'mobx';

export class ArticleCategoryModel {
  _articleCategory: IArticleCategory = defaultArticleCategoryEntity;
  _loading = false;

  get id() {
    return this.articleCategory.id;
  }

  get name() {
    return this.articleCategory.name;
  }

  get loading() {
    return this._loading;
  }

  set loading(loading: boolean) {
    this._loading = loading;
  }

  get articleCategory() {
    return this._articleCategory;
  }

  set articleCategory(articleCategory: IArticleCategory) {
    this._articleCategory = articleCategory;
  }

  fetchArticleCategory = async (id: number) => {
    try {
      const articleCategory = await getArticleCategoryById(id);

      if (articleCategory) {
        this.articleCategory = articleCategory;
      }
    } catch (e) {
      notify('Can`t load article category', 'error');

      setTimeout(() => {
        window.location.href = '/article-categoies/new';
      }, 500);
    }
  };

  manageArticleCategory = async (
    isUpdate: boolean,
    values: ICreateArticleCategory,
  ) => {
    this.loading = true;

    try {
      if (isUpdate) {
        await editArticleCategory(this.id, values);
      } else {
        await createArticleCategory(values);
      }

      notify(
        <div>
          Article category <strong>{values.name}</strong> was{' '}
          {isUpdate ? 'updated' : 'created'} succesfully!
        </div>,
      );

      return true;
    } catch (e) {
      notify(
        `Failed to ${isUpdate ? 'update' : 'create'} article category`,
        'error',
      );
    } finally {
      this.loading = false;
    }
  };

  fetchData = async (
    articleCategoryId?: number,
    articleCategory?: IArticleCategory,
  ) => {
    this.loading = true;

    try {
      if (articleCategory) {
        this._articleCategory = articleCategory;
      }

      if (articleCategoryId && !articleCategory) {
        await this.fetchArticleCategory(articleCategoryId);
      }
    } catch (e) {
      notify(`Error, reason:${e}`, 'error');
    } finally {
      this.loading = false;
    }
  };

  constructor(articleCategoryId?: number, articleCategory?: IArticleCategory) {
    this.fetchData(articleCategoryId, articleCategory);

    makeAutoObservable(this);
  }
}
